import { useEffect, useState } from "react";
import { Navbar } from "../components/Navbar";
import { HeroSequence } from "../components/HeroSequence";
import { IntroSection } from "../components/IntroSection";
import { ValueSection } from "../components/ValueSection";
import { FeaturedProjects } from "../components/FeaturedProjects";
import { ContactCTA } from "../components/ContactCTA";
import { Footer } from "../components/Footer";
import { getCategories, getProjects } from "../lib/api";

export default function Landing() {
  const [categories, setCategories] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    getCategories().then(setCategories).catch(() => {});
    getProjects(true).then(setProjects).catch(() => {});
  }, []);

  return (
    <div className="grain relative bg-[#FFFFFF]">
      <Navbar />
      <main>
        <HeroSequence />
        <IntroSection />
        <ValueSection />
        <FeaturedProjects projects={projects} categories={categories} filter={filter} setFilter={setFilter} />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
